import { inject as W, defineComponent as k, useCssVars as L, unref as r, computed as x, openBlock as m, createElementBlock as y, withModifiers as oe, normalizeClass as _, createBlock as M, h as H, ref as E, resolveDynamicComponent as le, mergeProps as se, createCommentVNode as A, renderSlot as ne, createElementVNode as f, toDisplayString as K, mergeModels as J, useModel as ie, watch as ce, onBeforeMount as ue, onBeforeUnmount as de, createVNode as z, TransitionGroup as pe, withCtx as me, Fragment as Q, renderList as ge, withKeys as ve, nextTick as fe } from "vue";
import { a as he, t as X, s as N, k as be, _ as q, b as we, M as V, p as ye, g as Ce } from "../kittchat.es.js";
const P = () => W(he, {
  t: (e, t) => X(e, t) || e,
  tc: (e, t, n) => X(e, n) || e
}), F = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, l] of t)
    n[o] = l;
  return n;
};
function U(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var _e = typeof global == "object" && global && global.Object === Object && global, xe = typeof self == "object" && self && self.Object === Object && self, ae = _e || xe || Function("return this")(), Y = function() {
  return ae.Date.now();
}, Te = /\s/;
function Me(e) {
  for (var t = e.length; t-- && Te.test(e.charAt(t)); )
    ;
  return t;
}
var ke = /^\s+/;
function Le(e) {
  return e && e.slice(0, Me(e) + 1).replace(ke, "");
}
var I = ae.Symbol, re = Object.prototype, Se = re.hasOwnProperty, Be = re.toString, O = I ? I.toStringTag : void 0;
function $e(e) {
  var t = Se.call(e, O), n = e[O];
  try {
    e[O] = void 0;
    var o = !0;
  } catch {
  }
  var l = Be.call(e);
  return o && (t ? e[O] = n : delete e[O]), l;
}
var Ae = Object.prototype, He = Ae.toString;
function ze(e) {
  return He.call(e);
}
var Oe = "[object Null]", Ne = "[object Undefined]", Z = I ? I.toStringTag : void 0;
function je(e) {
  return e == null ? e === void 0 ? Ne : Oe : Z && Z in Object(e) ? $e(e) : ze(e);
}
function De(e) {
  return e != null && typeof e == "object";
}
var Ve = "[object Symbol]";
function Ee(e) {
  return typeof e == "symbol" || De(e) && je(e) == Ve;
}
var ee = NaN, Ie = /^[-+]0x[0-9a-f]+$/i, Pe = /^0b[01]+$/i, Fe = /^0o[0-7]+$/i, Re = parseInt;
function te(e) {
  if (typeof e == "number")
    return e;
  if (Ee(e))
    return ee;
  if (U(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = U(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Le(e);
  var n = Pe.test(e);
  return n || Fe.test(e) ? Re(e.slice(2), n ? 2 : 8) : Ie.test(e) ? ee : +e;
}
var Ye = "Expected a function", Ke = Math.max, Ue = Math.min;
function We(e, t, n) {
  var o, l, a, s, c, d, h = 0, i = !1, b = !1, S = !0;
  if (typeof e != "function")
    throw new TypeError(Ye);
  t = te(t) || 0, U(n) && (i = !!n.leading, b = "maxWait" in n, a = b ? Ke(te(n.maxWait) || 0, t) : a, S = "trailing" in n ? !!n.trailing : S);
  function T(u) {
    var g = o, w = l;
    return o = l = void 0, h = u, s = e.apply(w, g), s;
  }
  function j(u) {
    return h = u, c = setTimeout(B, t), i ? T(u) : s;
  }
  function R(u) {
    var g = u - d, w = u - h, G = t - g;
    return b ? Ue(G, a - w) : G;
  }
  function D(u) {
    var g = u - d, w = u - h;
    return d === void 0 || g >= t || g < 0 || b && w >= a;
  }
  function B() {
    var u = Y();
    if (D(u))
      return $(u);
    c = setTimeout(B, R(u));
  }
  function $(u) {
    return c = void 0, S && o ? T(u) : (o = l = void 0, s);
  }
  function p() {
    c !== void 0 && clearTimeout(c), h = 0, o = d = l = c = void 0;
  }
  function v() {
    return c === void 0 ? s : $(Y());
  }
  function C() {
    var u = Y(), g = D(u);
    if (o = arguments, l = this, d = u, g) {
      if (c === void 0)
        return j(d);
      if (b)
        return clearTimeout(c), c = setTimeout(B, t), T(d);
    }
    return c === void 0 && (c = setTimeout(B, t)), s;
  }
  return C.cancel = p, C.flush = v, C;
}
const qe = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M13.03 4.47a.75.75 0 010 1.06L8.56 10l4.47 4.47a.75.75 0 11-1.06 1.06l-5-5a.75.75 0 010-1.06l5-5a.75.75 0 011.06 0z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, o.appendChild(a);
  }
  const l = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return H(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, Ge = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 011.06 0L10 8.94l4.47-4.47a.75.75 0 111.06 1.06L11.06 10l4.47 4.47a.75.75 0 11-1.06 1.06L10 11.06l-4.47 4.47a.75.75 0 01-1.06-1.06L8.94 10 4.47 5.53a.75.75 0 010-1.06z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, o.appendChild(a);
  }
  const l = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return H(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, Je = ["aria-label"], Qe = /* @__PURE__ */ k({
  __name: "ActionButton",
  props: {
    type: { default: "close" },
    color: {},
    overColor: {},
    size: { default: "medium" }
  },
  emits: ["action-click"],
  setup(e, { emit: t }) {
    L((h) => ({
      "5be0768a": s.value,
      "61a71047": c.value,
      "908a0cea": r(l).borderRadius
    }));
    const n = e, o = t, l = N(), { t: a } = P(), s = x(() => n.color ?? "#333"), c = x(() => n.overColor ?? l.actionColor.base), d = We(() => {
      o("action-click");
    }, 200, { leading: !0, trailing: !1 });
    return (h, i) => (m(), y("button", {
      type: "button",
      onMousedown: i[0] || (i[0] = oe(
        //@ts-ignore
        (...b) => r(d) && r(d)(...b),
        ["left"]
      )),
      onClick: i[1] || (i[1] = //@ts-ignore
      (...b) => r(d) && r(d)(...b)),
      "data-testid": "action-trigger",
      "aria-label": n.type === "close" ? r(a)("Close") : r(a)("Back"),
      class: _(["actionTrigger", `actionTrigger--${n.size}`])
    }, [
      h.type === "close" ? (m(), M(r(Ge), {
        key: 0,
        "aria-label": r(a)("Close"),
        class: "actionTrigger__icon close"
      }, null, 8, ["aria-label"])) : (m(), M(r(qe), {
        key: 1,
        "aria-label": r(a)("Back"),
        class: "actionTrigger__icon back"
      }, null, 8, ["aria-label"]))
    ], 42, Je));
  }
}), Xe = /* @__PURE__ */ F(Qe, [["__scopeId", "data-v-69dca2dc"]]), Ze = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 3.211a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 3.211zM10 4.083a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zm3.03 4.553a.75.75 0 010 1.06L9.697 13.03a.75.75 0 01-1.06 0L6.97 11.363a.75.75 0 111.06-1.06l1.137 1.136 2.803-2.803a.75.75 0 011.06 0z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, o.appendChild(a);
  }
  const l = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return H(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, et = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 21" fill="currentColor">
  <path fill-rule="evenodd" d="M6.843 3.211a8.25 8.25 0 116.314 15.244A8.25 8.25 0 016.843 3.211zM10 4.083a6.75 6.75 0 100 13.5 6.75 6.75 0 000-13.5zM7.803 8.636a.75.75 0 011.06 0L10 9.772l1.136-1.136a.75.75 0 011.061 1.06l-1.136 1.137 1.136 1.136a.75.75 0 01-1.06 1.061L10 11.894 8.864 13.03a.75.75 0 11-1.061-1.06l1.136-1.137-1.136-1.136a.75.75 0 010-1.061z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, o.appendChild(a);
  }
  const l = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return H(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, tt = /* @__PURE__ */ k({
  inheritAttrs: !1,
  __name: "WidgetInput",
  props: {
    type: { default: "text" },
    modelValue: { default: "" },
    name: {},
    error: { type: Boolean },
    success: { type: Boolean },
    disabled: { type: Boolean },
    multiline: { type: Boolean },
    hideBorder: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    L((i) => ({
      e2d60f2e: c.value
    }));
    const n = t, o = e, { t: l } = P(), a = E(null), s = x(() => o.multiline ? "textarea" : "input"), c = x(() => !o.hideBorder && "1px solid #D3D3D3"), d = x(() => {
      const i = typeof o.modelValue == "string" && /^\s*http/i.test(o.modelValue);
      return o.type === "email" || i ? o.modelValue.replace(/\s/g, "") : o.modelValue;
    });
    function h(i) {
      n("update:modelValue", i.target.value);
    }
    return (i, b) => (m(), y("div", {
      class: _(["widget-input", { disabled: i.disabled, error: i.error, success: i.success }])
    }, [
      (m(), M(le(s.value), se({
        ref_key: "input",
        ref: a,
        type: i.type,
        id: i.name,
        name: i.name,
        value: d.value,
        disabled: i.disabled,
        "aria-label": i.name
      }, i.$attrs, {
        onInput: h,
        class: "widget-input__input"
      }), null, 16, ["type", "id", "name", "value", "disabled", "aria-label"])),
      i.error ? (m(), M(r(et), {
        key: 0,
        "aria-label": r(l)("Remove icon"),
        class: "widget-input__icon widget-input__icon--error"
      }, null, 8, ["aria-label"])) : A("", !0),
      i.success ? (m(), M(r(Ze), {
        key: 1,
        "aria-label": r(l)("Checkmark icon"),
        class: "widget-input__icon widget-input__icon--success"
      }, null, 8, ["aria-label"])) : A("", !0)
    ], 2));
  }
}), ot = /* @__PURE__ */ F(tt, [["__scopeId", "data-v-15de587f"]]), nt = /* @__PURE__ */ k({
  __name: "FloatingWindow",
  props: {
    mode: { default: "window" },
    shadowMode: { default: "standard" },
    position: { default: "bottom" }
  },
  setup(e) {
    L((o) => ({
      "7a6b1627": r(n).borderRadius,
      "3cf47f2e": r(n).borderColor
    }));
    const t = e, n = N();
    return (o, l) => (m(), y("div", {
      class: _([
        "floating-window",
        `floating-window--${t.mode}`,
        `floating-window--${t.position}`,
        `floating-window--shadow-${t.shadowMode}`,
        { "floating-window--bordered": r(n).border }
      ])
    }, [
      ne(o.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), $t = /* @__PURE__ */ F(nt, [["__scopeId", "data-v-c18fbfc1"]]), at = (e, t) => {
  const n = "http://www.w3.org/2000/svg", o = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M9.47 6.97a.75.75 0 011.06 0l5 5a.75.75 0 11-1.06 1.06L10 8.56l-4.47 4.47a.75.75 0 01-1.06-1.06l5-5z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const a = document.createElementNS(n, "title");
    a.textContent = e.title, o.appendChild(a);
  }
  const l = Array.from((o == null ? void 0 : o.attributes) ?? []).reduce((a, s) => ({
    ...a,
    [s.name]: s.value
  }));
  return H(
    "svg",
    {
      ...l,
      ...t.attrs,
      role: "img",
      innerHTML: o.innerHTML
    }
  );
}, rt = { class: "w-full" }, lt = /* @__PURE__ */ k({
  __name: "FloatingTrigger",
  props: {
    open: { type: Boolean, default: !1 },
    position: { default: "top" },
    showChevron: { type: Boolean, default: !0 }
  },
  setup(e) {
    L((l) => ({
      "28d9bc58": r(n).mainColor.base,
      e214c930: r(n).mainColor.contrasted,
      "28dff25b": r(n).mainColor.over
    }));
    const t = e, n = N(), { t: o } = P();
    return (l, a) => (m(), y("button", {
      type: "button",
      tabindex: "0",
      class: _([
        "trigger",
        { "trigger--open": t.open, position: l.position },
        t.position === "top" ? "trigger--top" : "trigger--bottom"
      ])
    }, [
      f("div", rt, [
        ne(l.$slots, "default", {}, void 0, !0)
      ]),
      t.showChevron ? (m(), M(r(at), {
        key: 0,
        "aria-label": r(o)("Arrow icon"),
        class: "trigger__arrow"
      }, null, 8, ["aria-label"])) : A("", !0)
    ], 2));
  }
}), At = /* @__PURE__ */ F(lt, [["__scopeId", "data-v-d7713c7b"]]);
function Ht(e) {
  const t = {
    LT: "UL",
    RT: "UR",
    LM: "CL",
    RM: "CR",
    LB: "LL",
    RB: "LR"
  };
  return x(() => e in t ? t[e] : e);
}
const st = (e, t) => {
  const n = "http://www.w3.org/2000/svg", l = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
  <path fill-rule="evenodd" d="M10 3.417a.75.75 0 01.53.22l5 5a.75.75 0 01-1.06 1.06l-3.72-3.72v9.856a.75.75 0 11-1.5 0V5.977l-3.72 3.72a.75.75 0 11-1.06-1.06l5-5a.75.75 0 01.53-.22z" clip-rule="evenodd"/>
</svg>
`, "image/svg+xml").firstChild;
  if (e.title) {
    const s = document.createElementNS(n, "title");
    s.textContent = e.title, l.appendChild(s);
  }
  const a = Array.from((l == null ? void 0 : l.attributes) ?? []).reduce((s, c) => ({
    ...s,
    [c.name]: c.value
  }));
  return H(
    "svg",
    {
      ...a,
      ...t.attrs,
      role: "img",
      innerHTML: l.innerHTML
    }
  );
};
var it = /* @__PURE__ */ ((e) => (e.COLLAPSED = "collapsed", e.EXPANDED = "expanded", e))(it || {});
const ct = (e) => {
  e.value && e.value.scrollHeight !== 0 && (e.value.scrollTop + e.value.clientHeight >= e.value.scrollHeight || e.value.scrollTo({
    top: e.value.scrollHeight,
    behavior: "smooth"
  }));
}, ut = () => W(be), dt = {
  class: "m-auto",
  "test-id": "text"
}, pt = /* @__PURE__ */ k({
  __name: "ChatAvatar",
  props: {
    agentName: {},
    size: { default: "small" },
    colors: { default: () => ({
      bgColor: "bg-primary-500",
      textColor: "text-white"
    }) }
  },
  setup(e) {
    L((a) => ({
      "58e87cab": a.colors.bgColor,
      "57ba2583": a.colors.textColor
    }));
    const t = e, n = {
      small: "w-8 h-8 text-sm",
      big: "w-10 h-10 text-xl"
    }, o = x(() => {
      var a;
      return `${(a = t.agentName) == null ? void 0 : a.charAt(0)}`.toUpperCase();
    }), l = x(() => n[t.size]);
    return (a, s) => (m(), y("div", {
      class: _([
        "ChatAvatar",
        l.value
      ])
    }, [
      f("span", dt, K(o.value || "K"), 1)
    ], 2));
  }
}), mt = /* @__PURE__ */ q(pt, [["__scopeId", "data-v-5c754a62"]]), gt = { class: "w-fit" }, vt = /* @__PURE__ */ k({
  __name: "Loader",
  setup(e) {
    L((n) => ({
      "749a55a8": r(t).mainColor.base
    }));
    const t = N();
    return (n, o) => (m(), y("div", gt, o[0] || (o[0] = [
      f("div", { class: "dot-falling" }, null, -1)
    ])));
  }
}), ft = /* @__PURE__ */ q(vt, [["__scopeId", "data-v-3f5b9a2f"]]), ht = {
  class: "kitt-chat",
  role: "dialog"
}, bt = {
  key: 0,
  class: "flex items-center p-2"
}, wt = { class: "flex-1 flex items-center gap-3" }, yt = { class: "font-semibold ml-1" }, Ct = { class: "pr-1" }, _t = {
  class: "disclaimer",
  title: "Disclaimer"
}, xt = { class: "text-base-700 text-center max-w-[300px]" }, Tt = {
  key: 0,
  class: "mx-4 mt-2"
}, Mt = ["innerHTML"], kt = ["disabled"], Lt = /* @__PURE__ */ k({
  __name: "KittChat",
  props: /* @__PURE__ */ J({
    isTyping: { type: Boolean }
  }, {
    modelValue: {
      default: []
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ J(["collapse", "sendMessage"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    L((p) => ({
      "264fa4e2": r(s).backgroundColor.base,
      "4bdbf142": r(s).backgroundColor.contrasted,
      "44073b19": `${r(s).backgroundColor.base}1A`,
      "662e1717": r(s).actionColor.base,
      "66344d1a": r(s).actionColor.over
    }));
    const n = ie(e, "modelValue"), o = e, l = t, { t: a } = P(), s = N(), c = E(), d = E(""), h = E(0), i = ut(), b = x(() => (i == null ? void 0 : i.device) === "mobile"), S = x(() => {
      var p;
      return ((p = i == null ? void 0 : i.deviceStyleConfig) == null ? void 0 : p.agentName) || "KITT";
    });
    async function T() {
      await fe(), ct(c);
    }
    async function j() {
      if (!d.value || o.isTyping) return;
      const p = d.value.trim().replace(/[<>&"']/g, (v) => {
        switch (v) {
          case "<":
            return "&lt;";
          case ">":
            return "&gt;";
          case "&":
            return "&amp;";
          case '"':
            return "&quot;";
          case "'":
            return "&#39;";
          default:
            return v;
        }
      }).replace(/\[([^\]]+)]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
      l("sendMessage", {
        id: Ce(),
        content: p,
        owner: V.USER
      }), d.value = "", await T();
    }
    const R = (p) => {
      if (c.value) {
        const { scrollTop: v, scrollHeight: C, clientHeight: u } = c.value, g = v === 0, w = v + u >= C;
        (g && p.deltaY < 0 || w && p.deltaY > 0) && p.preventDefault();
      }
    }, D = (p) => {
      h.value = p.touches[0].clientY;
    }, B = (p) => {
      if (!c.value) return;
      const { scrollTop: v, scrollHeight: C, clientHeight: u } = c.value, w = p.touches[0].clientY - h.value;
      (v === 0 && w > 0 || v + u >= C && w < 0) && (p.preventDefault(), p.stopPropagation());
    }, $ = W(we);
    return ce(n, T), ue(() => {
      $ && ($.syncMessagesScroll.value = T, $.openConnection());
    }), de(() => {
    }), (p, v) => (m(), y("div", ht, [
      f("header", {
        class: _(["header", { "mb-4": !b.value }])
      }, [
        b.value ? (m(), y("div", bt, [
          f("div", wt, [
            f("h1", yt, [
              f("span", Ct, K(S.value), 1)
            ])
          ]),
          z(r(Xe), {
            type: "close",
            color: r(s).backgroundColor.contrasted,
            onActionClick: v[0] || (v[0] = (C) => p.$emit("collapse"))
          }, null, 8, ["color"])
        ])) : A("", !0)
      ], 2),
      f("section", {
        ref_key: "messagesContainer",
        ref: c,
        "aria-label": "Chat messages",
        class: "messageContainer",
        onWheel: R,
        onTouchmove: B,
        onTouchstart: D
      }, [
        f("section", _t, [
          f("p", xt, K(r(a)("This conversation will be recorded for quality and training purposes.")), 1)
        ]),
        z(pe, {
          tag: "ul",
          name: "messages",
          class: "p-4 flex flex-col gap-4 overflow-hidden"
        }, {
          default: me(() => [
            (m(!0), y(Q, null, ge(n.value, ({ id: C, content: u, owner: g, loading: w }) => (m(), y(Q, { key: C }, [
              g !== r(V).SYSTEM ? (m(), y("li", {
                key: 0,
                class: _([
                  "flex items-end gap-2 relative",
                  "chat-message",
                  g === r(V).USER ? "justify-end" : "justify-start"
                ])
              }, [
                g === r(V).ASSISTANT ? (m(), M(mt, {
                  key: 0,
                  "agent-name": S.value,
                  size: "small",
                  colors: {
                    bgColor: r(s).mainColor.base,
                    textColor: r(s).backgroundColor.contrasted
                  }
                }, null, 8, ["agent-name", "colors"])) : A("", !0),
                f("div", {
                  class: _([
                    "max-w-72 min-h-8",
                    "p-3 rounded-lg relative",
                    `chat-message-${!w && g}`
                  ])
                }, [
                  w ? (m(), y("div", Tt, [
                    z(ft)
                  ])) : (m(), y("div", {
                    key: 1,
                    innerHTML: r(ye)(u)
                  }, null, 8, Mt))
                ], 2)
              ], 2)) : A("", !0)
            ], 64))), 128))
          ]),
          _: 1
        })
      ], 544),
      f("footer", {
        class: _([
          "flex items-center gap-3",
          "px-4 py-2 mt-2 border-t",
          "chat-input",
          p.isTyping && "opacity-60"
        ])
      }, [
        z(r(ot), {
          modelValue: d.value,
          "onUpdate:modelValue": v[1] || (v[1] = (C) => d.value = C),
          readonly: p.isTyping,
          placeholder: r(a)("Type a reply..."),
          class: "w-full shadow-none",
          type: "text",
          name: "message",
          "hide-border": "",
          role: "presentation",
          autocomplete: "off",
          onKeydown: ve(oe(j, ["prevent"]), ["enter"])
        }, null, 8, ["modelValue", "readonly", "placeholder", "onKeydown"]),
        f("button", {
          type: "button",
          disabled: p.isTyping || !d.value,
          onClick: j
        }, [
          f("div", {
            class: _([
              "w-8 h-8 bg-black flex rounded-full text-white",
              "chat-button",
              d.value.trim() ? "active" : "disabled"
            ])
          }, [
            z(r(st), { class: "w-5 h-5 m-auto" })
          ], 2)
        ], 8, kt)
      ], 2)
    ]));
  }
}), zt = /* @__PURE__ */ q(Lt, [["__scopeId", "data-v-eba57990"]]);
export {
  At as F,
  zt as K,
  it as V,
  $t as h,
  Ht as r,
  F as s
};
//# sourceMappingURL=KittChat.CFBaYI0_.js.map
